import React from "react";
import "./MiddleCard.css";

const MiddleCard = (props) => {
  return (
    <div className="middlecard mt-5">
      <div className="card mx-auto">
        <div className="cardhead">
          <h4>{props.title}</h4>
        </div>
        <div className="cardmiddle mb-2 mt-2 text-center text-white">
          {props.dec}
        </div>
        <ul className="mb-5">
          <li className="plan me-5 mb-5 p-1">
            <a href="https://buy.domain.com" className="text-center w-full">
              Join Presale
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MiddleCard;
